export const mobileAlignOffset: [number, number] = [0, 20];
export const desktopAlignOffset: [number, number] = [40, 0];
